import React from 'react';
import { GetCabinClass } from '../utils/staticpackagedetails';
const FlightDetails = ({flightItem, resourceKeys}) => {
    const sourceCityName = flightItem?.Source?.split('-')[0];
    const destinationCityName = flightItem?.Destination?.split('-')[0];
    
    return (
        <>
           <div className="box_wrap SPdetWrap common_bdrBtm w-100 p-4">
                    <h4 className="SPdethead">{resourceKeys.your_flight || 'Your Flight'}</h4>
                    <div className="itenary-item">
                        <div className="itenary-head d-flex flex-wrap align-items-center">
                        <div className="itenary-day-label">{resourceKeys.Day || 'Day'} {flightItem?.DayNo}</div>
                        <h3>{sourceCityName} - {destinationCityName}</h3>
                        </div>
                        <div className="spflDtls d-flex flex-wrap justify-content-between">
                        <div className="flpaxAirlines">
                        <img
                                src={`${process.env.REACT_APP_BASE_URL}${flightItem.AirlineImage}`}
                                alt={flightItem.Airline}
                                />

                            <div className="paxairlineDtls">
                            <p>{flightItem?.Airline}</p>
                            {/* <p>ET852</p> */}
                            <p>{GetCabinClass(flightItem?.CabinClass, resourceKeys)}</p>
                            </div>
                        </div>
                        <div className="paxsumryDest">
                            <div className="paxdestL">
                            <h4>{flightItem?.SourceTime}</h4>
                            {/* <p>25 Jun</p> */}
                            <p>{flightItem?.Source?.split('-')[1]} </p>
                            </div>
                            <div className="paxsmryStops">
                            <div className="airDurationStops">
                                <div className="stop-overs">
                                {/* <span className="stops td-tooltip">
                                    CAI
                                    <span className="tooltiptext">
                                    <span>{flightItem?.Duration}</span>
                                    <span> stopover</span> <br />
                                    Cairo Intl Airport
                                    </span>
                                </span> */}
                                </div>
                                <span className="flightIcon">
                                <i className="icon-flight-2" />
                                </span>
                                <span>{resourceKeys.total_time}: {flightItem?.Duration}</span>
                            </div>
                            </div>
                            <div className="paxdestL paxdestR">
                            <h4>{flightItem?.DestinationTime}</h4>
                            {/* <p>26 Jun</p> */}
                            <p>{flightItem?.Destination?.split('-')[1]} </p>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div> 
        </>
    );
}

export default FlightDetails;
